/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatsAccuracy
 */
export interface StatsAccuracy {
    /**
     * 
     */
    n: number;
    /**
     * 
     */
    medianAbsPct: number;
    /**
     * 
     */
    within10Pct: number;
    /**
     * 
     */
    within20Pct: number;
}

/**
 * Check if a given object implements the StatsAccuracy interface.
 */
export function instanceOfStatsAccuracy(value: object): value is StatsAccuracy {
    if (!('n' in value) || value['n'] === undefined) return false;
    if ((!('medianAbsPct' in (value as Record<string, any>)) && !('median_abs_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['medianAbsPct'] === undefined && (value as Record<string, any>)['median_abs_pct'] === undefined)) return false;
    if ((!('within10Pct' in (value as Record<string, any>)) && !('within_10_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['within10Pct'] === undefined && (value as Record<string, any>)['within_10_pct'] === undefined)) return false;
    if ((!('within20Pct' in (value as Record<string, any>)) && !('within_20_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['within20Pct'] === undefined && (value as Record<string, any>)['within_20_pct'] === undefined)) return false;
    return true;
}

export function StatsAccuracyFromJSON(json: any): StatsAccuracy {
    return StatsAccuracyFromJSONTyped(json, false);
}

export function StatsAccuracyFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsAccuracy {
    if (json == null) {
        return json;
    }
    return {
        
        'n': json['n'],
        'medianAbsPct': json['median_abs_pct'],
        'within10Pct': json['within_10_pct'],
        'within20Pct': json['within_20_pct'],
    };
}

export function StatsAccuracyToJSON(json: any): StatsAccuracy {
    return StatsAccuracyToJSONTyped(json, false);
}

export function StatsAccuracyToJSONTyped(value?: StatsAccuracy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'n': value['n'],
        'median_abs_pct': value['medianAbsPct'],
        'within_10_pct': value['within10Pct'],
        'within_20_pct': value['within20Pct'],
    };
}

